import { useContext, useEffect, useState } from "react";

import magicbook1 from "../../../images/BOOKassetNEW_1.gif";
import magicbook2 from "../../../images/BOOKassetNEW_2.gif";
import magicbook3 from "../../../images/BOOKassetNEW_3.gif";
import roomAsset from "../../../images/room_asset2.png";

import { Player, PlayerAction } from "../../../types";
import { constants } from "../../../constants";
import { config } from "../../../config";
import Avatar from "../../common/avatar/avatar";
import Waitable from "../../common/waitable/waitable";
import { GameStatus } from "../../../types/game-status";
import StateButton from "../../common/state-button/state-button";
import { useAppSelector } from "../../../redux/store";
import GamePage from "../game-page/game-page";
import { GameContext } from "../../../contexts";
import { Maturity } from "../../../types";
import { useTranslation } from "react-i18next";
import Button from "@/components/ui/button";

const Lobby = () => {
  const { submit } = useContext(GameContext);

  // const [footer, setFooter] = useState("")
  const gameState = useAppSelector((state) => state.game);
  const playerState = useAppSelector((state) => state.player);
  const [imgCount, setImgCount] = useState(0);

  const [checked, setChecked] = useState(-1);

  const { t } = useTranslation(["game", "common"]);

  useEffect(() => {
    let interval = setInterval(() => {
      setImgCount((prev) => (prev + 1) % 2);
    }, 1000);

    return () => clearInterval(interval);
  });

  function handleExit() {
    let playerAction: PlayerAction = {
      // room_id: Gamers.roomDetails?.room?.id as string,
      // player_id: Gamers.roomDetails?.player?.id as string,
      // player_secret: Gamers.roomDetails?.player?.secret as string,
      code: "game/exit",
      body: {},
      // game_id: gameState.gameId as string,
    };
    submit(playerAction);

    // setPage(PageNumber.Main)
  }

  function handleKick() {
    if (checked !== playerState.player?.id) {
      let playerAction: PlayerAction = {
        body: {
          vip_action: {
            kick_player: checked,
          },
        },
        code: "game/vip",
      };
      submit(playerAction);
    }
  }

  function handleBook() {
    let playerAction: PlayerAction = {
      // room_id: Gamers.roomDetails?.room?.id as string,
      // player_id: Gamers.roomDetails?.player?.id as string,
      // player_secret: Gamers.roomDetails?.player?.secret as string,
      code: "game/start",
      body: {},
      // game_id: gameState.gameId as string,
    };
    submit(playerAction);
    // setFooter("Loading...")
  }

  function makeAvatars2() {
    // let players = gameState.game?.players as Player[]
    let players = [] as Player[];
    if (gameState.game?.players) {
      players = gameState.game?.players;
    }

    // players = players.sort((a, b) => (a.id as number) - (b.id as number) ?? 0)
    let divs = [];
    let playerIdx = 0;
    for (let i = 0; i < 20; i++) {
      if (i === 13 || i === 14 || i === 17 || i === 18) {
        divs.push(
          <div key={"lobby-element-" + i} className={"w-1/4"}>
            <div className="relative w-full flex after:content-[''] after:block after:pb-[100%]" />
          </div>
        );
      } else {
        let player = players[playerIdx++];

        divs.push(
          <div key={"lobby-element-" + i} className={"w-1/4"}>
            <div className="relative w-full flex after:content-[''] after:block after:pb-[100%]">
              {playerIdx <= (gameState.game?.settings?.max_players ?? 16) && (
                <Avatar
                  variant="lobby"
                  spriteId={player?.meta?.sprite_id ?? 0}
                  onClick={(playerId) =>
                    setChecked((ps) =>
                      ps === playerId || playerId === playerState.player?.id
                        ? -1
                        : playerId
                    )
                  }
                  checked={checked === player?.id}
                  key={i}
                  player={player}
                  closed={
                    playerIdx > (gameState.game?.settings?.max_players ?? 16)
                  }
                />
              )}
            </div>
          </div>
        );
      }
    }
    return divs;
  }

  function newFooter() {
    if (!gameState.game?.settings) {
      return;
    }
    const startGuide = gameState.game?.settings.show_instructions
      ? t("lobby.footers.startGuideOn")
      : t("lobby.footers.startGuideOff");

    let gameSpeed: string;

    if (gameState.game?.settings.write_duration >= constants.leisureSpeed) {
      gameSpeed = t("speeds.leisurely", { ns: "common" });
    } else if (
      gameState.game?.settings.write_duration >= constants.briskSpeed
    ) {
      gameSpeed = t("speeds.brisk", { ns: "common" });
    } else if (
      gameState.game?.settings.write_duration >= constants.franticSpeed
    ) {
      gameSpeed = t("speeds.frantic", { ns: "common" });
    } else if (
      gameState.game?.settings.write_duration >= constants.lightningSpeed
    ) {
      gameSpeed = t("speeds.lightning", { ns: "common" });
    } else {
      gameSpeed = t("speeds.sonic", { ns: "common" });
    }
    const maturity =
      gameState.game?.settings.maturity === Maturity.MATURE
        ? t("label.mature", { ns: "common" })
        : t("label.allAges", { ns: "common" });

    const label = [startGuide, gameSpeed, maturity].join(" | ");

    return (
      <>
        <StateButton
          onClick={handleExit}
          states={[
            amHost()
              ? t("lobby.footers.closeGame")
              : t("lobby.footers.leaveGame"),
            t("lobby.footers.areYouSure"),
          ]}
        />
        <div
          className={
            "flex-grow text-sm text-center flex justify-center items-center mx-2 leading-none"
          }
        >
          {label}
        </div>
        {amHost() ? (
          <Button disabled={checked <= 0} onClick={handleKick}>
            {t("button.kickPlayer", { ns: "common" })}
          </Button>
        ) : (
          ""
        )}
      </>
    );
  }

  function clickable() {
    return (
      gameState.game?.players &&
      gameState.game?.players?.length >= config.minimumLobbySize
    );
  }

  function amHost() {
    return gameState.game?.host_id === playerState.player?.id;
  }

  function disabled() {
    return !amHost();
  }

  function shouldFlash() {
    return (
      gameState.game?.players &&
      gameState.game?.players?.length >= config.minimumLobbySize
    );
  }

  function subheaders() {
    return [t("lobby.subheaders.defaultOne"), t("lobby.subheaders.defaultTwo")];
  }

  return (
    <Waitable
      playerActionHandler={() => { }}
      waitingFor={[GameStatus.GameStatusPostLobby]}
      waitHeader={t("lobby.headers.waiting")}
    >
      <GamePage
        hideAvatar
        subHeaders={subheaders()}
        titles={[t("lobby.headers.default")]}
        footerJsx={newFooter()}
      >
        <div className="flex-grow flex bg-contain bg-no-repeat flex-col w-full" style={{ backgroundImage: `url(${roomAsset})` }}>
          <div className="pt-8 flex-grow relative flex flex-row flex-wrap justify-center [&>*]:min-h-0">
            {makeAvatars2()}

            <button
              className="h-[35%] absolute bottom-0 left-1/2 -translate-x-1/2 border-0 p-0 bg-transparent shadow-none flex flex-col-reverse"
              onClick={handleBook}
              disabled={disabled() || !clickable()}
            >
              {shouldFlash() ? (
                <img
                  className={"w-full h-full relative"}
                  src={
                    disabled()
                      ? magicbook2
                      : imgCount === 0
                        ? magicbook2
                        : magicbook3
                  }
                  alt="submit"
                />
              ) : (
                <img
                  className={"w-full h-full relative"}
                  src={magicbook1}
                  alt="submit"
                />
              )}
            </button>
          </div>
        </div>
      </GamePage>
    </Waitable>
  );
};

export default Lobby;
